import DateRangePicker from './DateRangePicker';

export default DateRangePicker;

export type { DateRangeValue } from './DateRangePicker';
